import { render, staticRenderFns } from "./comp_CheckoutSummary.vue?vue&type=template&id=7bbb176a&scoped=true"
import script from "./comp_CheckoutSummary.vue?vue&type=script&lang=js"
export * from "./comp_CheckoutSummary.vue?vue&type=script&lang=js"
import style0 from "./comp_CheckoutSummary.vue?vue&type=style&index=0&id=7bbb176a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbb176a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
